module.exports = __webpack_public_path__ + "static/img/discussion_member_03_ph.69a8d4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/discussion_member_03_ph.png
// module id = gPh0
// module chunks = 0